import React, { Fragment } from 'react';
import { object, bool } from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { GlobalStyle, Page } from './styles';
import GlobalNavigation from './Navigation';
import Title from './components/Title';
import CheckoutHeader from './components/CheckoutHeader';
import BreadCrumb from './components/BreadCrumb';
import SignIn from './pages/SignIn';
import SignOut from './pages/SignOut';
import Register from './pages/Register';
import SocialAuthRedirect from './pages/SocialAuthRedirect';
import MarketingPreferences from './pages/MarketingPreferences';
import Store from './redux/store';
import getPageTitle from './utils/getPageTitle';
import { isInCheckoutFlow } from './redux/utils/redirect';
import { errorPropType } from './prop-types';
import { ROUTES } from './constants';

export const App = ({ loggedIn, location, error }) => {
  const inCheckoutFlow = isInCheckoutFlow(location.search);
  const isSignIn = location.pathname && location.pathname.startsWith(ROUTES.SIGN_IN);
  const inMarketingPrefPage =
    location.pathname && location.pathname.startsWith(ROUTES.MARKETING_PREFERENCES);
  const showBreadCrumb = !inCheckoutFlow && !(inMarketingPrefPage && !loggedIn);

  return (
    <Fragment>
      {!inCheckoutFlow && <GlobalNavigation />}
      <GlobalStyle />
      {inCheckoutFlow && <CheckoutHeader isSignIn={isSignIn} />}
      {showBreadCrumb && (
        <BreadCrumb title={getPageTitle(location)} myAccount={inMarketingPrefPage} />
      )}
      {inMarketingPrefPage && loggedIn && <Title>{getPageTitle(location)}</Title>}
      <Page>
        <ConnectedRouter history={Store.history}>
          <Switch>
            <Route path="/u/register" component={Register} />
            <Route path="/u/sign-in" component={SignIn} />
            <Route path="/u/sign-out" component={SignOut} />
            <Route path="/u/social-auth-redirect" component={SocialAuthRedirect} />
            {loggedIn && <Route path="/u/marketing-preferences" component={MarketingPreferences} />}
          </Switch>
        </ConnectedRouter>
      </Page>
    </Fragment>
  );
};

App.propTypes = {
  loggedIn: bool.isRequired,
  location: object,
  error: errorPropType,
};

App.defaultProps = {
  location: {},
  error: null,
};

const mapStateToProps = state => ({
  loggedIn: state.loggedIn,
  location: state.router.location || {},
  error: state.signIn.error,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
